import React from "react";

const Hero = () => {
  return (
    <section
      className="hero"
      style={{ backgroundImage: "url(/images/hero-background.png)" }}
    >
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">Locations mit WOW-EFFECT</h1>
          <p className="hero-subtitle">-</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
